import React from "react";
import EscapeCataloguePanel from "@/pages/admin/EscapeCataloguePanel";
import LegacyHost from "@/pages/admin/os/LegacyHost";

export default function EscapeModule() {
  return (
    <LegacyHost
      title="Escape"
      migratedFrom="Editorial desk · Escape catalogue"
      testid="os-modules-escape"
    >
      <EscapeCataloguePanel />
    </LegacyHost>
  );
}
